<template>
  <div class="contact">
    <div class="contact-icon">
      <img src="@/assets/images/contact-icon.png" alt="">
    </div>
    <div class="contact-info">
      <p>北京明世继元招标有限公司</p>
      <p>地址：北京市西城区马连道路11号一商大厦1503室</p>
      <p>电话：010-88683260</p>
      <p>传真：010-88683260</p>
      <p>邮箱：15963324200@163.com</p>
      <p>邮编：100071</p>
    </div>
    <div class="contact-img">
      <img src="@/assets/images/contact-img.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
  components: {},
  data() {
    return {}
  },
  methods: {},
  mounted() {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.contact
  width 1200px
  margin 0 auto 70px
  overflow hidden
  .contact-icon
    float left
  .contact-info
    float left
    margin-left 60px
    width 720px
    border-right 2px solid #d2d2d2
    box-sizing border-box
    p
      font-size 14px
      color #333
      line-height 25px
  .contact-img
    float left
    text-align center
    width 385px
</style>



// WEBPACK FOOTER //
// src/pages/Index/components/Contact.vue